export class CellRefColors
{
    public static readonly Colors:Array<string> = [
        '#F7981D',
        '#7E3794',
        '#11A9CC',
        '#A61D4C',
        '#4285F4',
        '#F4B400',
        '#65B045',
        '#795548',
        '#999999',
        '#F1CA3A',
        '#3F5CA9',
        '#C3D03F',
    ];

    // TODO: Make transparent
    public static readonly BackgroundColors:Array<string> = [
        '#F7981D',
        '#7E3794',
        '#11A9CC',
        '#A61D4C',
        '#4285F4',
        '#F4B400',
        '#65B045',
        '#795548',
        '#999999',
        '#F1CA3A',
        '#3F5CA9',
        '#C3D03F',
    ];

    public static getColorByIndex(index:number, isBackground:boolean = false):string
    {
        const repeatedIndex:number = index % CellRefColors.Colors.length;
        return isBackground ? CellRefColors.BackgroundColors[repeatedIndex] : CellRefColors.Colors[repeatedIndex];
    }
}
